import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=356e5337&scoped=true&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"
import style0 from "./blackList.vue?vue&type=style&index=0&id=356e5337&scoped=true&lang=css&"
import style1 from "./blackList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e5337",
  null
  
)

export default component.exports